/* eslint-disable
    import/no-dynamic-require,
    import/no-unresolved,
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
require('./dmsStatementSummaryTable/dmsStatementSummaryTable.scss');
require('./dmsReceiptTable/dmsReceiptTable.scss');
require('./dmsStatementTable/dmsStatementTable.scss');
require('./dmsOtherTable/dmsOtherTable.scss');
require('./dmsAddOnTable/dmsAddOnTable.scss');

const deps = [require('ui/web/documentPreview').name];

module.exports = angular
  .module('bench.ui.dmsTable', deps)

  .directive('blDmsTable', $compile => ({
    restrict: 'E',
    scope: {
      documentCollectionId: '=',
      documentType: '=',
      archived: '=',
    },
    bindToController: true,
    controller: require('./dmsTableCtrl.js'),
    controllerAs: 'vm',
    link(scope, element, attrs) {
      const template = (() => {
        switch (scope.vm.documentType) {
          case 'TAX':
            return require('./dmsTaxTable/dmsTaxTable.html');
          case 'RECEIPT':
            return require('./dmsReceiptTable/dmsReceiptTable.html');
          case 'STATEMENT':
            return require(scope.vm.archived != null
              ? './dmsStatementSummaryTable/dmsStatementSummaryTable.html'
              : './dmsStatementTable/dmsStatementTable.html');
          case 'ADD_ON':
            return require('./dmsAddOnTable/dmsAddOnTable.html');
          default:
            return require('./dmsOtherTable/dmsOtherTable.html');
        }
      })();

      element.html(template).show();

      return $compile(element.contents())(scope);
    },
  }));
